export default "__VITE_ASSET__Dgv4hbsH__"